const style = {
  inputLabel: {
    margin: 5,
  },
  row: { alignItems: 'center' },
  paddingRight: { paddingRight: 15 },
};

export default style;
